<template>
  <div id="room-bulletinboard" ref="bulletinboard">
    <RoomPinnedItem
      v-if="pinned_message != null && 
            pinned_message != undefined && 
            Object.keys(pinned_message).length > 0 && 
            canShowForPinned(pinned_message_id)"
      :message_id="pinned_message_id"
      :message="pinned_message"
      :reaction="reactions[pinned_message_id] || null"
      :is_login="is_login"
      :current_user_id="current_user_id"
      :ref="pinned_message_id"
    />
    <transition-group name="list">
      <RoomMessageItem
        v-for="(message_id, index) in message_ids"
        :key="message_id"
        :can_show="canShow(index)"
        :message_id="message_id"
        :message="messages[index]"
        :reaction="reactions[message_id] || null"
        :is_login="is_login"
        :current_user_id="current_user_id"
        :ref="message_id"
        :index="index"
      />
    </transition-group>
    <div v-if="is_loadable">
      <div
        v-observe-visibility="{
          callback: loadMoreMessages,
          throttleOptions: {
            leading: 'visible',
          },
        }"
      >
        <br />読み込み中...
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import RoomMessageItem from "./RoomMessageItem.vue";
import RoomPinnedItem from "./RoomPinnedItem.vue";

// safari scroll
import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();

import { db } from "./../../App.vue";

const MESSAGE_LOADING_LIMIT = 25;
const MESSAGE_SAVING_LIMIT = 100;

export default {
  name: "RoomMessageList",
  components: {
    RoomMessageItem,
    RoomPinnedItem,
  },
  props: {
    is_login: Boolean,
    current_user_id: String,
  },
  data: function () {
    return {
      // データ構造などの説明は ./../admin/components/RoomMessageList.vue を参照
      messages: [],
      message_ids: [],
      reactions: {},
      hidden_messages: {},
      pinned_message: {},
      // 追加されるのは1データのみだが、他のコンポーネントに配列で渡す必要があるため
      pinned_message_id: null,
      is_loadable: true,
    };
  },
  created: function () {
    let self = this;

    // messages
    db.ref(`messages/${this.roomId}`)
      .orderByKey()
      .limitToLast(MESSAGE_LOADING_LIMIT)
      .on("child_added", function (snapshot) {
        self.messages.unshift(snapshot.val());
        self.message_ids.unshift(snapshot.key);

        // 表示件数 3,000 件を超えたあたりからアニメーションがカクつくため、
        // 表示件数に上限を設け、自動スクロールが ON の場合は古いものを自動削除する
        if (
          self.isEnabledAutoScroll() &&
          self.message_ids.length > MESSAGE_SAVING_LIMIT
        ) {
          self.messages.splice(MESSAGE_SAVING_LIMIT);
          self.message_ids.splice(MESSAGE_SAVING_LIMIT);
          self.is_loadable = true;
        }
      });

    // reactions
    db.ref(`reactions/${this.roomId}`).on("child_added", function (snapshot) {
      const [message_id, user_id] = snapshot.key.split(":");
      if (self.reactions[message_id] == undefined) {
        let new_reaction = {};
        new_reaction[user_id] = true;
        self.$set(self.reactions, message_id, new_reaction);
      } else {
        self.$set(self.reactions[message_id], user_id, snapshot.val());
      }
    });
    db.ref(`reactions/${this.roomId}`).on("child_removed", function (snapshot) {
      const [message_id, user_id] = snapshot.key.split(":");
      self.$delete(self.reactions[message_id], user_id);
    });

    // hidden_messages
    db.ref(`hidden_messages/${this.roomId}`).on("child_added", function (
      snapshot
    ) {
      self.$set(self.hidden_messages, snapshot.key, snapshot.val());
    });
    db.ref(`hidden_messages/${this.roomId}`).on("child_removed", function (
      snapshot
    ) {
      self.$delete(self.hidden_messages, snapshot.key);
    });

    // pinned_messages
    db.ref(`pinned_messages/${this.roomId}`).on("child_added", function (
      snapshot
    ) {
      db.ref(`messages/${self.roomId}/${snapshot.key}`)
        .once("value", function (snapshot) {
          self.pinned_message = snapshot.val();
          self.pinned_message_id = snapshot.key;
      });
    });
    db.ref(`pinned_messages/${this.roomId}`).on("child_removed", function (
    ) {
      Object.keys(self.pinned_message).forEach(key => {
        self.$delete(self.pinned_message, key);
      });
      self.pinned_message_id = null;
    });

    // messages 総数が MESSAGE_LOADING_LIMIT 未満である場合、「読み込み中」を非表示にする
    db.ref(`messages/${this.roomId}`)
      .limitToLast(MESSAGE_LOADING_LIMIT)
      .once("value")
      .then(function (snapshot) {
        self.is_loadable = snapshot.numChildren() == MESSAGE_LOADING_LIMIT;
      });
  },
  computed: {
    roomId: function () {
      return this.$route.params.room_id;
    },
  },
  methods: {
    canShow: function (index) {
      if (this.pinned_message_id === this.message_ids[index]) {
        return false;
      } else if (this.hidden_messages[this.message_ids[index]] != undefined) {
        // 投稿者本人は閲覧できる
        return this.messages[index].user_id === this.current_user_id;
      }
      return true;
    },
    canShowForPinned: function (message_id) {
      if (this.hidden_messages[message_id] != undefined) {
        return false;
      }
      return true;
    },
    loadMoreMessages(is_visible) {
      if (!is_visible || this.messages.length === 0) {
        return;
      }
      let self = this;
      db.ref(`messages/${this.roomId}`)
        .orderByKey()
        .endAt(this.message_ids[this.message_ids.length - 1])
        .limitToLast(MESSAGE_LOADING_LIMIT)
        .once("value", function (snapshot) {
          const num_of_child = snapshot.numChildren();

          // 上限一杯まで取得できたのであれば、まだ継続して読み込める
          self.is_loadable = num_of_child == MESSAGE_LOADING_LIMIT;

          if (num_of_child == 0) {
            return;
          }

          let loaded_messages = [];
          let loaded_message_ids = [];
          snapshot.forEach(function (child_snapshot) {
            loaded_messages.unshift(child_snapshot.val());
            loaded_message_ids.unshift(child_snapshot.key);
          });

          // firebase のクエリ endAt では等しいものを含めて取得するため、重複を取り除く必要がある
          loaded_messages.shift();
          loaded_message_ids.shift();

          self.messages = self.messages.concat(loaded_messages);
          self.message_ids = self.message_ids.concat(loaded_message_ids);
        });
    },
    isEnabledAutoScroll: function () {
      const scrollTop =
        window.document.body.scrollTop ||
        window.document.documentElement.scrollTop;
      return scrollTop < 20; // 20px は自動スクロールがされていると判定する適当な値。実際は 0 に近いはず。
    },
  },
};
</script>

<style lang="scss" scoped>
.list-enter-active {
  transition: all 0.3s ease-out;
  position: relative;
  z-index: -1;
}
.list-enter {
  transform: translateY(-100%);
}
#room-bulletinboard {
  margin-top: $topbar_height;
  margin-bottom: $bottombar_height + 30px;
  padding: 0px 5px;
}
.room-bulletinboard-message > .row-custom {
  padding-top: 7px;
}
</style>
